import { Accordion, AccordionItem } from "@heroui/accordion";
import { Link } from "react-router-dom";

import NavCard from "./nav-card";

import useScreenSize from "@/hooks/useScreenSize";
import {
  dataTech,
  edTech,
  hrmSolution,
  lifeStyle,
  projectManage,
  salesPlatforms,
} from "@/assets/data/navbar";

export default function ProductNav() {
  const isMdScreen = useScreenSize("md");

  if (isMdScreen) {
    const menus = [
      { title: edTech.title, data: edTech },
      { title: dataTech.title, data: dataTech },
      { title: salesPlatforms.title, data: salesPlatforms },
      // { title: "Project Management", data: projectManagement },
      { title: hrmSolution.title, data: hrmSolution },
      { title: projectManage.title, data: projectManage },
      { title: lifeStyle.title, data: lifeStyle },
    ];

    return (
      <Accordion variant="splitted">
        {menus.map((menu) => (
          <AccordionItem
            key={menu.title}
            aria-label={menu.title}
            classNames={{
              trigger: "py-2.5",
              base: "border-none !bg-transparent shadow-none",
            }}
            title={menu.title}
          >
            <ul>
              {menu.data.list.map((item) => {
                const isInternal = item.link.startsWith("/");

                return (
                  <li key={item.label}>
                    {isInternal ? (
                      <Link
                        className="block px-5 py-2.5 w-full text-left text-sub-title hover:text-secondary transition-colors"
                        to={item.link}
                      >
                        {item.label}
                      </Link>
                    ) : (
                      <a
                        className="block px-5 py-2.5 w-full text-left text-sub-title hover:text-secondary transition-colors"
                        href={item.link}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {item.label}
                      </a>
                    )}
                  </li>
                );
              })}
            </ul>
          </AccordionItem>
        ))}
      </Accordion>
    );
  }

  return (
    <NavCard>
      <div className="grid md:grid-cols-3 gap-12">
        <NavCard.ListItem list={edTech.list} title={edTech.title} />
        <NavCard.ListItem list={dataTech.list} title={dataTech.title} />
        <NavCard.ListItem
          list={salesPlatforms.list}
          title={salesPlatforms.title}
        />
      </div>
      <div className="grid md:grid-cols-3 gap-12 mt-10">
        <NavCard.ListItem list={hrmSolution.list} title={hrmSolution.title} />
        <NavCard.ListItem
          list={projectManage.list}
          title={projectManage.title}
        />
        <NavCard.ListItem list={lifeStyle.list} title={lifeStyle.title} />
      </div>
    </NavCard>
  );
}
